import React from "react";
import "./usercard.scss";

import axios from "axios";
import { toast } from "react-toastify";

import EmojiEnable from "../../assets/88.png";
import EmojiError from "../../assets/820.png";

const Usercard = ({ data }) => {
  const bann = async () => {
    try {
      // SET AUTH HEADER
      axios.defaults.headers.common["x-auth-token"] = sessionStorage.getItem(
        "kzvb-obleute"
      );

      await axios.put(`/api/v1/users/bann/${data._id}`);
      toast.warning(
        `Benutzer ${data.firstname} ${data.lastname} wurde gebannt.`
      );
    } catch (err) {
      console.log(err.response);
      if (err.response && err.response.data)
        err.response.data.map((message) => toast.error(message.msg));
      else {
        toast.error(err.message);
      }
    }
  };

  const enable = async () => {
    try {
      // SET AUTH HEADER
      axios.defaults.headers.common["x-auth-token"] = sessionStorage.getItem(
        "kzvb-obleute"
      );

      await axios.put(`/api/v1/users/enable/${data._id}`);
      toast.success(
        `Benutzer ${data.firstname} ${data.lastname} wurde freigeschalten.`
      );
    } catch (err) {
      console.log(err.response);
      if (err.response && err.response.data)
        err.response.data.map((message) => toast.error(message.msg));
      else {
        toast.error(err.message);
      }
    }
  };

  return (
    <figure className='usercard'>
      {data.picture && data.picture.url ? (
        <div className='usercard__image'>
          <img
            src={`${
              process.env.NODE_ENV === "production"
                ? window.location.origin
                : "http://localhost:8000"
            }/${data.picture.url}`}
            alt=''
          />
        </div>
      ) : (
        <div className='usercard__icon'>
          {data && (
            <span>
              {data.firstname.charAt(0)}
              {data.lastname.charAt(0)}
            </span>
          )}
        </div>
      )}
      <div className='usercard__title'>
        <span className='usercard__title--name'>
          {data &&
            `${data.title ? `${data.title} ` : ""}${data.firstname} ${
              data.lastname
            }`}
        </span>
        <span className='usercard__title--tag'>@{data && data.tag}</span>
      </div>
      <div className='usercard__actions'>
        <div className='usercard__actions__item' onClick={() => enable()}>
          <img src={EmojiEnable} alt='' />
        </div>
        <div className='usercard__actions__item' onClick={() => bann()}>
          <img src={EmojiError} alt='' />
        </div>
      </div>
    </figure>
  );
};

export default Usercard;
